import { useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { LucideHome, FileText, Mic2, FolderOpenDot, Menu, X, CreditCard, Crown, Sparkles } from "lucide-react";
import { Badge } from "../ui/badge";
import { AsyncCreditWrapper, CreditStatus, UpgradeButton } from '../dashboard/creditstatus';

const ProtectedLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  // Simulate loading
  useState(() => {
    setTimeout(() => setIsLoading(false), 1000);
  });

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="flex h-screen bg-[#f8fafc] dark:bg-[#020617]">
      {/* Mobile Navigation Header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 h-16 bg-[#f8fafc] dark:bg-[#020617] border-b border-gray-200 dark:border-gray-800 flex items-center justify-between px-4 z-50">
        <div className="flex items-center space-x-2">
          <span className="text-2xl text-gray-800 dark:text-gray-100 font-semibold tracking-tight">
            SpeakClearlyAI
            {isLoading ? (
              <div className="ml-2 h-6 w-16 bg-gray-200 dark:bg-gray-800 rounded-full animate-pulse inline-block" />
            ) : (
              <Badge variant="secondary" className="absolute top- right-10000 font-small text-sm text-blue-600 dark:text-blue-100">BETA</Badge>
            )}
          </span>
        </div>
        <button 
          onClick={toggleSidebar}
          className="h-10 w-10 flex items-center justify-center bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-xl hover:bg-blue-200 dark:hover:bg-blue-900/50 transition-colors"
        >
          {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Sidebar */}
      <div className={`
        fixed lg:static w-[300px] h-full bg-[#f8fafc] dark:bg-[#020617] border-r border-gray-200 dark:border-gray-800 shadow-lg
        transform transition-transform duration-300 ease-in-out z-50
        ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        <div className="flex flex-col h-full px-8 py-8">
          <div className="hidden lg:flex items-center space-x-2 mb-16">
            <span className="text-3xl text-gray-800 dark:text-gray-100 font-semibold tracking-tight">
              Speakclearly AI
              {isLoading ? (
                <div className="ml-2 h-6 w-16 bg-gray-200 dark:bg-gray-800 rounded-full animate-pulse inline-block" />
              ) : (
                <Badge variant="secondary" className="absolute top- right-4 font-small text-sm text-blue-600 dark:bg-blue-900 dark:text-blue-100">BETA</Badge>
              )}
            </span>
          </div>
          
          <nav className="space-y-4">
            <Link to="/dashboard">
              <div className={`flex items-center space-x-4 px-5 py-2.5 rounded-2xl transition-colors ${
                location.pathname === '/dashboard' 
                  ? 'bg-blue-100 dark:bg-blue-100/10 text-blue-600 dark:text-blue-500' 
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800/80'
              }`}>
                <LucideHome size={24} />
                <span className="text-lg font-medium">Home</span>
              </div>
            </Link>
            
            <div className="flex items-center justify-between px-5 py-2.5 rounded-2xl text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800/80">
              <div className="flex items-center space-x-4">
                <FileText size={24} />
                <span className="text-lg font-medium">Templates</span>
              </div>
              <Badge variant="secondary" className="font-normal text-sm bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-100">Soon</Badge>
            </div>
            
            
             <Link to={"/tts"}> <div className="flex items-center justify-between px-5 py-2.5 rounded-2xl text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800/80">
                <div className="flex items-center space-x-4">
                  <Mic2 size={24} />
                  <span className="text-lg font-medium">Text To Speech</span>
                </div>
                {/* <Badge variant="secondary" className="font-normal text-sm bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-100">Soon</Badge> */}
              </div></Link>
          
            
            <Link to={"/creationfiles"}>
            <div className="flex items-center space-x-4 px-5 py-2.5 rounded-2xl text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800/80">
              <FolderOpenDot size={24} />
              <span className="text-lg font-medium">My Creations</span>
            </div>
            </Link>
            
           <Link to={"/myfiles"}>
           <div className="flex items-center space-x-4 px-5 py-2.5 rounded-2xl text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800/80">
              <FileText size={24} />
              <span className="text-lg font-medium">My Files</span>
            </div>
            </Link>
          </nav>
          
          <div className="mt-auto space-y-4">
          <AsyncCreditWrapper>
        <CreditStatus />
        <UpgradeButton />
      </AsyncCreditWrapper>
</div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto lg:pt-0 pt-16 bg-white/50 dark:bg-gray-900/50">
        <Outlet />
      </div>
    </div>
  );
};

export default ProtectedLayout;